import { render } from "./insurance-new.vue?vue&type=template&id=0d6057ea&scoped=true&ts=true"
import script from "./insurance-new.vue?vue&type=script&lang=ts"
export * from "./insurance-new.vue?vue&type=script&lang=ts"

import "./insurance-new.vue?vue&type=style&index=0&id=0d6057ea&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d6057ea"]])

export default __exports__